import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { toast } from "sonner";
import { usePaypalConfig } from "../lib/paypal";
import { createCartPaypalOrder, captureCartPaypalOrder } from "../lib/api";

const STYLE = { layout: "vertical", color: "gold", shape: "pill", label: "paypal", height: 46 };

// Real PayPal Checkout for the basket. `validate` gates the click, `getPayload`
// returns the current cart+contact, `onPaid(orderId)` fires after server capture.
export const CartPayPalButtons = ({ validate, getPayload, onPaid }) => {
  const paypal = usePaypalConfig();
  if (paypal.loading) {
    return <p className="text-sm text-[#787069]">Loading PayPal…</p>;
  }
  if (!paypal.options) {
    return (
      <p className="text-sm text-[#787069]" data-testid="cart-paypal-unconfigured">
        PayPal is not configured yet.
      </p>
    );
  }

  return (
    <div data-testid="cart-paypal-buttons">
      <PayPalScriptProvider options={paypal.options}>
        <PayPalButtons
          style={STYLE}
          createOrder={async () => {
            if (validate && !validate()) throw new Error("invalid_contact");
            try {
              const res = await createCartPaypalOrder(getPayload());
              return res.id;
            } catch (e) {
              toast.error(`Could not start PayPal checkout: ${e.message}`);
              throw e;
            }
          }}
          onApprove={async (data) => {
            try {
              const res = await captureCartPaypalOrder(data.orderID, getPayload());
              if (res.status === "paid") {
                toast.success("Payment received — thank you!");
                onPaid?.(data.orderID);
              } else {
                toast.error("Payment could not be completed.");
              }
            } catch (e) {
              toast.error(`Payment capture failed: ${e.message}`);
            }
          }}
          onError={(err) => {
            console.error("[PayPal] button error:", err);
            if (String(err?.message || err) !== "invalid_contact") {
              toast.error("PayPal encountered an error. Please try another method.");
            }
          }}
        />
      </PayPalScriptProvider>
      <p className="mt-3 text-xs text-[#787069] text-center">Secured by PayPal{paypal.env === "sandbox" ? " · Sandbox test mode" : ""}</p>
    </div>
  );
};
